import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { IExtensionState } from "./extension.types";
import { LocalStorageKeys } from "../../constants";

const extensionSlice = createSlice({
  name: "extension",
  initialState,
  reducers: {
    updateExtension: (
      state,
      action: PayloadAction<Partial<IExtensionState>>,
    ) => {
      console.log("Updating extension slice: ", action.payload);
      const result = { ...state, ...action.payload };
      localStorage.setItem(
        LocalStorageKeys.IS_EXTENSION,
        (result.isExtension || false).toString(),
      );
      return result;
    },
  },
});

export const { updateExtension } = extensionSlice.actions;

export default extensionSlice.reducer;
